import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue";
import _imports_0 from '@/assets/imgs/map-screenshot.png';
const _hoisted_1 = {
  id: "about"
};
const _hoisted_2 = {
  class: "box"
};
const _hoisted_3 = {
  class: "about-wrapper"
};
const _hoisted_4 = {
  class: "slogan"
};
const _hoisted_5 = {
  class: "contact-card"
};
import { ref } from 'vue';
export default {
  __name: 'AboutSection',
  props: {
    showAddress: Boolean
  },
  emits: ['show-dialog', 'toggle-address'],
  setup(__props) {
    const showDialog = ref(false);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[7] || (_cache[7] = _createStaticVNode("<div class=\"about-item\" data-v-161ebbda><div class=\"logo\" data-v-161ebbda></div><div class=\"vertical-divider\" data-v-161ebbda></div><div class=\"company-info\" data-v-161ebbda><p class=\"company-intro\" data-v-161ebbda>把每一次脑电波，翻译成一夜好眠。</p></div></div><div class=\"middle-area-1\" data-v-161ebbda><h4 data-v-161ebbda>产品服务</h4><span data-v-161ebbda>智能解决方案</span><span data-v-161ebbda>技术咨询服务</span><span data-v-161ebbda>定制开发</span><span data-v-161ebbda>运维支持</span></div><div class=\"middle-area-2\" data-v-161ebbda><h4 data-v-161ebbda>新闻动态</h4><span data-v-161ebbda>公司最新动态</span><span data-v-161ebbda>行业资讯</span><span data-v-161ebbda>技术文章</span><span data-v-161ebbda>活动公告</span></div>", 3)), _createElementVNode("div", _hoisted_4, [_cache[5] || (_cache[5] = _createElementVNode("span", {
        class: "title"
      }, "创新导向 卓越追求", -1)), _cache[6] || (_cache[6] = _createElementVNode("span", {
        class: "title"
      }, "客户至上 团队合作", -1)), _createElementVNode("span", {
        class: "contact-us",
        onClick: _cache[0] || (_cache[0] = $event => showDialog.value = true)
      }, "联系我们>"), (_openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(_Transition, {
        name: "pop"
      }, {
        default: _withCtx(() => [showDialog.value ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "mask",
          onClick: _cache[2] || (_cache[2] = _withModifiers($event => showDialog.value = false, ["self"]))
        }, [_createElementVNode("div", _hoisted_5, [_cache[3] || (_cache[3] = _createElementVNode("img", {
          src: _imports_0,
          alt: "地图"
        }, null, -1)), _cache[4] || (_cache[4] = _createElementVNode("div", {
          class: "info"
        }, [_createElementVNode("h3", null, "联系我们"), _createElementVNode("p", null, "地址：江苏省无锡市新吴区清源路20号立业楼C栋二楼213"), _createElementVNode("p", null, "电话：400-xxx-xxxx"), _createElementVNode("p", null, "邮箱：contact@yourcompany.com")], -1)), _createElementVNode("span", {
          class: "close",
          onClick: _cache[1] || (_cache[1] = $event => showDialog.value = false)
        }, "✕")])])) : _createCommentVNode("", true)]),
        _: 1
      })]))])])])]);
    };
  }
};